import { render, staticRenderFns } from "./block-organizations-success.vue?vue&type=template&id=558368ea&scoped=true&lang=pug"
import script from "./block-organizations-success.vue?vue&type=script&lang=js"
export * from "./block-organizations-success.vue?vue&type=script&lang=js"
import style0 from "./block-organizations-success.vue?vue&type=style&index=0&id=558368ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558368ea",
  null
  
)

export default component.exports